import styled from 'styled-components';
import { SvgIcon } from '../../Icon';
import { theme } from '../../../styles/theme';
import TickCheckbox from '../../Checkbox';

export const Container = styled.div`
  display: block;
  margin-bottom: 24px;
`;

export const MenuContainer = styled.div`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${theme.colors.secondary800};

  &:hover {
    background-color: ${theme.colors.contentHighlight};
  }
`;

export const MenuSelectAllInput = styled(TickCheckbox)`
  margin-right: 8px;
`;

export const OptionContainer = styled.div<{ $isSelected: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${(props) =>
    props.$isSelected ? theme.colors.contentHighlight : 'transparent'};

  &:hover {
    background-color: ${theme.colors.contentHighlight};
  }
`;

export const OptionContent = styled.div`
  display: flex;
  align-items: center;
`;

export const OptionCheckbox = styled(TickCheckbox)`
  margin-right: 8px;
`;

export const OptionLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OptionLabel = styled.div`
  color: ${theme.colors.secondary800};
`;

export const OptionDate = styled.div`
  color: ${theme.colors.secondary400};
`;

export const OptionData = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const OptionIcon = styled(SvgIcon)`
  margin-right: 4px;
  height: 16px;
  width: 16px;
`;

export const Label = styled.div`
  margin-bottom: 8px;
`;

export const IndicatorsContainer = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
`;
